import { Stack } from 'react-bootstrap';
import { TripConfig } from './TripConfig';

function Background(){
    return <div className="container">
        <div style={{maxWidth: "800px"}}>{TripConfig.backgroundText}</div>
        <Stack>
            <div style={{textAlign: "center"}}><b>{TripConfig.backgroundImageCaption}</b></div>
        <img style={{maxWidth: "800px", height:"auto"}} src={`/img/${TripConfig.backgroundImage}`}/>
        </Stack>
      </div>
}

export default Background;